



























import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import {
  JinroGameHistoryDocument,
  JinroPlayerDocument,
  JinroGamePlayinfoDocument,
} from "@/services/datatypes";
import { JinroPlayerParams } from "@/services/paramstypes";
import PlayerNameList from "@/components/shared/PlayerNameList.vue";
import { WhoWinsGame } from "@/services/who-wins-game";
import { JinroPlayStatus } from "@/services/jinro-play-status";

@Component({
  components: {
    PlayerNameList,
  },
})
export default class GeneralInfo extends Vue {
  @Prop() readonly jinroGameHistory!: JinroGameHistoryDocument;

  get title(): string {
    if (!this.jinroGameHistory) {
      return "";
    }
    return this.jinroGameHistory.jinroRoomTitle;
  }

  get defaultTxt(): string {
    if (!this.jinroGameHistory || !this.jinroGameHistory.jinroGame) {
      return "";
    }
    let plsts = "";
    const playStatus = this.jinroGameHistory.jinroGame.currentPlayStatus;
    const dayN = this.jinroGameHistory.jinroGame.currentDayN;
    if (playStatus === JinroPlayStatus.Execution) {
      plsts = "処刑";
    }
    if (playStatus === JinroPlayStatus.Night) {
      plsts = "夜";
    }
    return `${dayN}日目  ${plsts} `;
  }

  get gameResult(): string {
    if (!this.jinroGameHistory || !this.jinroGameHistory.jinroGame) {
      return "";
    }
    if (this.jinroGameHistory.jinroGame.whoWinsGame === WhoWinsGame.JinroTeam) {
      return "人狼陣営の勝利";
    }
    if (
      this.jinroGameHistory.jinroGame.whoWinsGame === WhoWinsGame.MurabitoTeam
    ) {
      return "村人陣営の勝利";
    }

    return "-";
  }

  get startDate(): string {
    if (!this.jinroGameHistory) {
      return "";
    }
    const date = this.jinroGameHistory
      .timeStarted as firebase.firestore.Timestamp;
    return date.toDate().toLocaleString();
  }

  get endDate(): string {
    if (!this.jinroGameHistory) {
      return "";
    }
    const date = this.jinroGameHistory
      .timeEnded as firebase.firestore.Timestamp;
    return date.toDate().toLocaleString();
  }

  get survivors(): Array<JinroPlayerDocument> {
    if (!this.jinroGameHistory || !this.jinroGameHistory.jinroGame) {
      return [];
    }
    return this.jinroGameHistory.jinroGame.survivorsWithRole!;
  }

  get killedPlayers(): Array<JinroPlayerDocument> {
    if (!this.jinroGameHistory || !this.jinroGameHistory.jinroGame) {
      return [];
    }
    return this.jinroGameHistory.jinroGame.killedPlayersWithRole!;
  }

  get killedPlayersByJinro(): Array<JinroPlayerDocument> {
    if (!this.jinroGameHistory || !this.jinroGameHistory.jinroGame) {
      return [];
    }
    return this.jinroGameHistory.jinroGame.killedPlayersByJinroAttack;
  }
}
